import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

interface PageBannerProps {
  title: string;
  subtitle?: string;
  breadcrumb?: { label: string; to?: string }[];
  bgImage?: string;
  darkOverlay?: boolean;
}

export default function PageBanner({
  title,
  subtitle,
  breadcrumb,
  bgImage,
  darkOverlay = true,
}: PageBannerProps) {
  return (
    <section className="relative pt-[72px]">
      <div className="relative h-[280px] md:h-[340px] overflow-hidden bg-foreground-950">
        {bgImage && (
          <>
            <img
              src={bgImage}
              alt={title}
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            {darkOverlay && (
              <div className="absolute inset-0 bg-foreground-950/65" />
            )}
          </>
        )}
        <div className="relative z-10 h-full flex flex-col items-center justify-center px-6 text-center">
          <h1 className="text-3xl md:text-5xl font-heading font-extrabold text-background-50 tracking-tight">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-4 text-sm md:text-base text-background-50/75 max-w-xl leading-relaxed">
              {subtitle}
            </p>
          )}
          {breadcrumb && (
            <nav className="mt-6 flex items-center gap-2 text-xs md:text-sm text-background-50/60">
              <Link to="/" className="hover:text-background-50 transition-colors cursor-pointer">
                HOME
              </Link>
              {breadcrumb.map((bc, i) => {
                const isLast = i === breadcrumb.length - 1;
                return (
                  <span key={bc.label} className="flex items-center gap-2">
                    <span className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-arrow-right-s-line text-[10px]" />
                    </span>
                    {isLast || !bc.to ? (
                      <span className="text-background-50/90 font-medium">{bc.label}</span>
                    ) : (
                      <Link to={bc.to!} className="hover:text-background-50 transition-colors cursor-pointer">
                        {bc.label}
                      </Link>
                    )}
                  </span>
                );
              })}
            </nav>
          )}
        </div>
      </div>
    </section>
  );
}